/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPersonalRealAmt
 */
export interface ExecRiskPersonalRealAmt {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPersonalRealAmt
     */
    PersonalAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPersonalRealAmt
     */
    RealAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskPersonalRealAmt interface.
 */
export function instanceOfExecRiskPersonalRealAmt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskPersonalRealAmtFromJSON(json: any): ExecRiskPersonalRealAmt {
    return ExecRiskPersonalRealAmtFromJSONTyped(json, false);
}

export function ExecRiskPersonalRealAmtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPersonalRealAmt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'PersonalAmt': !exists(json, 'PersonalAmt') ? undefined : json['PersonalAmt'],
        'RealAmt': !exists(json, 'RealAmt') ? undefined : json['RealAmt'],
    };
}

export function ExecRiskPersonalRealAmtToJSON(value?: ExecRiskPersonalRealAmt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PersonalAmt': value.PersonalAmt,
        'RealAmt': value.RealAmt,
    };
}

